import { render, staticRenderFns } from "./component-number.vue?vue&type=template&id=a28102ac"
import script from "./component-number.vue?vue&type=script&lang=js"
export * from "./component-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports